export class CreateChatDto {
  pageId: number;
  // businessId: string;
  toUser: string;
  content: string;
}
